import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata. Effettua l'accesso.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 animate-fade-up">
        <div>
          <h2 className="font-heading text-2xl font-bold tracking-tight">Nuova password</h2>
          <p className="text-sm text-muted-foreground mt-1">Scegli una nuova password per il tuo account.</p>
        </div>
        {!token && <div className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2">Token mancante o non valido.</div>}
        {error && <div className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2">{error}</div>}
        <div className="space-y-2">
          <Label htmlFor="pwd">Nuova password</Label>
          <Input id="pwd" data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
        </div>
        <Button data-testid="reset-submit" type="submit" className="w-full" disabled={loading || !token}>
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Reimposta password
        </Button>
        <div className="text-center">
          <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="w-4 h-4" /> Torna al login</Link>
        </div>
      </form>
    </div>
  );
}
